import { helperMultisort } from "../../../services/utils";
export const ResultadosGanadores = (JsonOrdenado) => {
  // seccion de Absolutos;
  var JsonOrdenadoAbsolutos = [];
  JsonOrdenado.forEach(function (value, index) {
    if (value.ab === 1) {
      JsonOrdenadoAbsolutos.push({
        ...JsonOrdenado[index],
        cat: JsonOrdenado[index].cat + " - Absoluto",
      });
    }
  });
  JsonOrdenadoAbsolutos = helperMultisort(
    JsonOrdenadoAbsolutos,
    ["codMod", "gen", "pR"],
    ["ASC", "ASC", "ASC"]
  );

  // seccion de por Categorias;

  var JsonOrdenadoCategorias = [];
  JsonOrdenado.forEach(function (value, index) {
    if (value.ab !== 1 && value.pG > 0) {
      if (JsonOrdenado[index].pCat <= JsonOrdenado[index].cg) {
        JsonOrdenadoCategorias.push(JsonOrdenado[index]);
      }
    }
  });
  JsonOrdenadoCategorias = helperMultisort(
    JsonOrdenadoCategorias,
    ["codMod", "cat", "gen", "pCat"],
    ["ASC", "ASC", "ASC", "ASC"]
  );

  // unir los dos arrays
  var JsonOrdenadoUnido = JsonOrdenadoAbsolutos.concat(JsonOrdenadoCategorias);
  return JsonOrdenadoUnido;
};

//------------------------------------------------------------------------------------
// Agrupa el array plano de ResultadosGanadores (absolutos + categorías, NO
// intercalado por modalidad) en modalidad -> categoria -> ganadores, para el
// tablero compacto. Usa un Map por codMod (no detección de cambio en una sola
// pasada) para que absolutos y categorías de la misma modalidad terminen en
// una sola caja en vez de duplicarse.
const quitarMilisegundos = (tiempo) => (tiempo ? String(tiempo).split(".")[0] : tiempo);

export const buildWinnersBoardData = (resultadosGanadores, eventSubEvents) => {
  const modalidadesMap = new Map();
  (resultadosGanadores || []).forEach((row) => {
    if (!modalidadesMap.has(row.codMod)) {
      const info = eventSubEvents && eventSubEvents["modalidad_" + row.codMod];
      modalidadesMap.set(row.codMod, {
        codMod: row.codMod,
        descripcionModalidad: info
          ? info.descripcionModalidad
          : "Modalidad " + row.codMod,
        categoriasMap: new Map(),
      });
    }
    const modGroup = modalidadesMap.get(row.codMod);
    const esAbsoluto = row.ab === 1;
    // Los absolutos de un mismo género se agrupan en una sola caja aunque
    // sus atletas vengan de categorías originales distintas (por eso la key
    // no puede usar row.cat para absolutos, que trae el nombre original).
    const catKey = esAbsoluto ? "ABSOLUTO|" + row.gen : row.cat + "|" + row.gen;
    if (!modGroup.categoriasMap.has(catKey)) {
      modGroup.categoriasMap.set(catKey, {
        cat: esAbsoluto ? "Absoluto" : row.cat,
        gen: row.gen,
        codCat: row.codCat,
        esAbsoluto,
        generoLabel:
          row.gen === "F" ? "Femenil" : row.gen === "M" ? "Mixto" : "Varonil",
        ganadores: [],
      });
    }
    modGroup.categoriasMap.get(catKey).ganadores.push({
      posicion: row.ab === 1 ? row.pR : row.pCat,
      num: row.num,
      nombre: row.nombre,
      tiempo: quitarMilisegundos(row.to || row.toMS),
    });
  });

  // Ordena las categorías por su código numérico (no por el nombre, para que
  // "Categoría 10" no quede alfabéticamente entre "Categoría 1" y "Categoría
  // 2"); los absolutos van siempre primero.
  const ordenarCategorias = (categorias) =>
    categorias.sort((a, b) => {
      if (a.esAbsoluto !== b.esAbsoluto) return a.esAbsoluto ? -1 : 1;
      return (a.codCat || 0) - (b.codCat || 0);
    });

  return Array.from(modalidadesMap.values())
    .map((m) => ({
      ...m,
      categorias: ordenarCategorias(Array.from(m.categoriasMap.values())),
    }))
    .sort((a, b) => a.codMod - b.codMod);
};

//------------------------------------------------------------------------------------
export const ResultadosGenerales = (JsonOrdenado) => {
  console.log("ImprimirDatos", JsonOrdenado);
  const finishers = JsonOrdenado.map((a) => ({
    ...a,
    finish: (a.finish = a.pG > 0 ? 0 : 1),
  }));

  const finishersSort = helperMultisort(
    finishers,
    ["codMod", "finish", "pG"],
    ["ASC", "ASC", "ASC"]
  );

  return finishersSort;
};

//------------------------------------------------------------------------------------
export const ResultadosRama = (JsonOrdenado) => {
  const finishers = JsonOrdenado.map((a) => ({
    ...a,
    finish: (a.finish = a.pG > 0 ? 0 : 1),
  }));

  const finishersSort = helperMultisort(
    finishers,
    ["codMod", "gen", "finish", "pR"],
    ["ASC", "ASC", "ASC", "ASC"]
  );
  return finishersSort;
};

//------------------------------------------------------------------------------------
export const ResultadosCategoria = (JsonOrdenado) => {
  const finishers = JsonOrdenado.map((a) => ({
    ...a,
    finish: (a.finish = a.pG > 0 ? 0 : 1),
  }));
  // seccion de Absolutos;
  var JsonOrdenadoAbsolutos = [];
  finishers.forEach(function (value, index) {
    if (value.ab === 1) {
      JsonOrdenadoAbsolutos.push({
        ...finishers[index],
        cat: finishers[index].cat + " - Absoluto",
      });
    }
  });
  JsonOrdenadoAbsolutos = helperMultisort(
    JsonOrdenadoAbsolutos,
    ["codMod", "gen", "pR"],
    ["ASC", "ASC", "ASC"]
  );

  // seccion de por Categorias;

  var JsonOrdenadoCategorias = [];
  finishers.forEach(function (value, index) {
    if (value.ab !== 1) {
      JsonOrdenadoCategorias.push(finishers[index]);
    }
  });
  JsonOrdenadoCategorias = helperMultisort(
    JsonOrdenadoCategorias,
    ["codMod", "cat", "gen", "finish", "pCat"],
    ["ASC", "ASC", "ASC", "ASC", "ASC"]
  );

  // unir los dos arrays
  var JsonOrdenadoUnido = JsonOrdenadoAbsolutos.concat(JsonOrdenadoCategorias);
  return JsonOrdenadoUnido;
};

// ###########################################################################

export const controlesArrayFunc = (puntosControl) => {
  var controlesArray = {};
  if (puntosControl != undefined) {
    var controles = puntosControl.val();
    for (var m in controles) {
      var modPC = controles[m].modalidadesPuntoDeControl;
      for (var n in modPC) {
        var modalidadIndex = n;
        var laps = modPC[n].laps;
        for (var d in laps) {
          if (controlesArray[modalidadIndex] == undefined) {
            controlesArray[modalidadIndex] = {};
            controlesArray[modalidadIndex].tamano = 0;
            controlesArray[modalidadIndex].titles = [];
            controlesArray[modalidadIndex].kilometro = [];
          }
          if (laps[d].tipoControl != 3) {
            controlesArray[modalidadIndex].tamano++;
            controlesArray[modalidadIndex].titles.push({
              descripcionPunto: laps[d].descripcionPunto,
              kilometro: laps[d].kilometro,
            });
            controlesArray[modalidadIndex].kilometro[
              "km-" + laps[d].kilometro
            ] = laps[d].kilometro;
          }
        }
      }
    }
  }

  return controlesArray;
};

export const ImprimirDatos = (
  JsonOrdenado,
  tipoReporte,
  correr,
  controles,
  IDEvento,
  timingConfig
) => {
  // tipo reporte tipo 1 = generales, tipo 2 = Rama, tipo 3 = Ganadores Categoria, Tipo 4 = Competidor especifico.

  var ModSig;
  var CatSig;
  var GenSig;
  var showControlesTitle = "";

  var indexAnterior = -1;
  var ArrayFilas = [];

  for (var i in JsonOrdenado) {
    // datos objeto actual
    var Mod = JsonOrdenado[i].mod;
    var codMod = JsonOrdenado[i].codMod;
    var Cat = JsonOrdenado[i].cat;
    var Gen = JsonOrdenado[i].gen;
    var PG = JsonOrdenado[i].pG;
    var AB = JsonOrdenado[i].ab;
    var ValorSubclasif = JsonOrdenado[i].valorSubclasif;
    var NombreSubclasif = JsonOrdenado[i].nombreSubclasificacion;

    const showAll = timingConfig && timingConfig.showAll ? true : false;
    if (showAll || PG > 0) {
      // datos objeto siguiente
      if (indexAnterior != -1) {
        ModAnt = JsonOrdenado[indexAnterior].codMod;
        CatAnt = JsonOrdenado[indexAnterior].cat;
        GenAnt = JsonOrdenado[indexAnterior].gen;
        ABAnt = JsonOrdenado[indexAnterior].ab;
        ValorSubclasifAnt = JsonOrdenado[indexAnterior].valorSubclasif;
        NombreSubclasifAnt = JsonOrdenado[indexAnterior].nombreSubclasificacion;
      } else {
        var ModAnt = 0;
        var CatAnt = "";
        var GenAnt = "";
        var ABAnt = 0;
        var ValorSubclasifAnt = "";
        var NombreSubclasifAnt = "";
      }
      var Insertar = { typeRow: 2, result: JsonOrdenado[i] };
      if (tipoReporte == 1) {
        // generales
        if (i == 0) {
          ArrayFilas.push({
            typeRow: 1,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
          });
          ArrayFilas.push({
            typeRow: 3,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
          });
          ArrayFilas.push(Insertar);
        } else if (codMod != ModAnt) {
          console.log(codMod + " " + ModAnt);
          ArrayFilas.push({
            typeRow: 1,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
          });
          ArrayFilas.push({
            typeRow: 3,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
          });
          ArrayFilas.push(Insertar);
        } else {
          ArrayFilas.push(Insertar);
        }
      } else if (tipoReporte == 2) {
        // Rama
        if (i == 0) {
          ArrayFilas.push({
            typeRow: 1,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
          });
          ArrayFilas.push({
            typeRow: 3,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
          });
          ArrayFilas.push(Insertar);
        } else if (codMod != ModAnt || Gen != GenAnt) {
          ArrayFilas.push({
            typeRow: 1,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
          });
          ArrayFilas.push({
            typeRow: 3,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
          });
          ArrayFilas.push(Insertar);
        } else {
          ArrayFilas.push(Insertar);
        }
      } else if (tipoReporte == 3 || tipoReporte == 4) {
        // Categoria

        if (AB == 1 && (codMod != ModAnt || Gen.localeCompare(GenAnt) != 0)) {
          ArrayFilas.push({
            typeRow: 1,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: true,
          });
          ArrayFilas.push({
            typeRow: 3,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
          });
          ArrayFilas.push(Insertar);
        }
        if (AB == 1 && codMod == ModAnt && Gen.localeCompare(GenAnt) == 0) {
          ArrayFilas.push(Insertar);
        }

        if (
          AB == 0 &&
          (codMod != ModAnt ||
            Gen.localeCompare(GenAnt) != 0 ||
            Cat.localeCompare(CatAnt) != 0)
        ) {
          ArrayFilas.push({
            typeRow: 1,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
          });
          ArrayFilas.push({
            typeRow: 3,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
          });
          ArrayFilas.push(Insertar);
        }
        if (
          AB == 0 &&
          codMod == ModAnt &&
          Gen.localeCompare(GenAnt) == 0 &&
          Cat.localeCompare(CatAnt) == 0
        ) {
          ArrayFilas.push(Insertar);
        }
      } else if (tipoReporte == 5) {
        // Subclasificación — mismo criterio que Rama (tipoReporte 2), con el
        // valor de la subclasificación (ej. "Mérida") como corte adicional, y
        // nombreSubclasificacion para que dos subclasificaciones distintas no
        // se mezclen si coinciden en el texto del valor.
        if (
          i == 0 ||
          codMod != ModAnt ||
          Gen != GenAnt ||
          ValorSubclasif != ValorSubclasifAnt ||
          NombreSubclasif != NombreSubclasifAnt
        ) {
          ArrayFilas.push({
            typeRow: 1,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
            valorSubclasif: ValorSubclasif,
            nombreSubclasificacion: NombreSubclasif,
          });
          ArrayFilas.push({
            typeRow: 3,
            reportType: tipoReporte,
            codMod: codMod,
            mod: Mod,
            cat: Cat,
            gen: Gen,
            ab: false,
            valorSubclasif: ValorSubclasif,
            nombreSubclasificacion: NombreSubclasif,
          });
          ArrayFilas.push(Insertar);
        } else {
          ArrayFilas.push(Insertar);
        }
      } else if (tipoReporte == 4) {
        // individual
      } else {
      }

      indexAnterior = i;
    }
  }
  return ArrayFilas;
};

export const ControlesAtleta = (puntosControl, resultado, controlesArray) => {
  var codMod = resultado.codMod;
  var controlesTiempos = [];
  var controlesTitle = "";
  var controlestamano = 0;
  if (puntosControl != "") {
    if (controlesArray["modalidad_" + codMod] != undefined) {
      controlestamano = controlesArray["modalidad_" + codMod].tamano;
    }
    var parciales = resultado.parciales;
    if (parciales != undefined) {
      for (var i in controlesArray["modalidad_" + codMod].kilometro) {
        var registrado = false;
        for (var e in parciales) {
          if (
            parciales[e].kpc ==
            controlesArray["modalidad_" + codMod].kilometro[i]
          ) {
            registrado = true;
            controlesTiempos.push({
              registred: true,
              value: parciales[e].tkpc,
              class: "",
            });
          }
        }
        if (!registrado) {
          controlesTiempos.push({
            registred: false,
            value: "N/R",
            class: "teal lighten-2",
          });
        }
      }
    } else {
      for (var i = 1; i <= controlestamano; i++) {
        controlesTiempos.push({
          registred: false,
          value: "N/R",
          class: "teal lighten-2",
        });
      }
    }
  }
  return controlesTiempos;
};

//#########################################################################################
export const ordenarPuntosDeControlDatos2 = (
  soloMeta,
  ResultadosEvento,
  control
) => {
  var JsonOrdenado = ResultadosEvento;

  var arrayPuntosControl = [];
  // seccion de Absolutos;
  var JsonKPC = [];

  for (var i in JsonOrdenado) {
    var value = JsonOrdenado[i];

    arrayPuntosControl.push();

    var num = value.num;
    var nombre = value.nombre;
    var kpc = value.mod;
    var mod = value.mod;
    var pCat = 0;
    var tiempo = value.to;
    var parciales = value.parciales;
    var fechaHora = value.fhm;

    // primera parte es la meta

    if (arrayPuntosControl.indexOf(pCat) == -1) {
      arrayPuntosControl.push(pCat);
    }

    var JsonObjeto = {};
    JsonObjeto.num = num;
    JsonObjeto.nombre = nombre;
    JsonObjeto.kpc = kpc;
    JsonObjeto.mod = mod;
    JsonObjeto.pCat = pCat;
    JsonObjeto.tiempo = tiempo;
    JsonObjeto.fechaHora = fechaHora;

    if (tiempo != "00:00:00" && (control == 0 || control == null)) {
      JsonKPC.push(JsonObjeto);
    }

    if (parciales != undefined && parciales != 0 && !soloMeta) {
      console.log("Parciales");
      parciales.forEach(function (value2) {
        var kpc = value2.kpc;
        var pCat = value2.pCat;
        var tiempo = value2.tkpc;
        var fechaHora = value2.fechaHoraPunto;

        if (arrayPuntosControl.indexOf(pCat) == -1) {
          arrayPuntosControl.push(pCat);
        }

        var JsonParcial = {};
        JsonParcial.num = num;
        JsonParcial.nombre = nombre;
        JsonParcial.kpc = kpc;
        JsonParcial.mod = mod;
        JsonParcial.pCat = pCat;
        JsonParcial.tiempo = tiempo;
        JsonParcial.fechaHora = fechaHora;
        if (tiempo != "00:00:00" && (control == pCat || control == null)) {
          JsonKPC.push(JsonParcial);
        }
      });
    }
  }

  JsonKPC = helperMultisort(JsonKPC, ["fechaHora"], ["DESC"]);

  return { JsonKPC: JsonKPC, arrayPuntosControl: arrayPuntosControl };
};
//#########################################################################################
export const ordenarPuntosDeControlDatos = (
  soloMeta,
  ResultadosEvento,
  control,
  anouncer
) => {
  var JsonOrdenado = ResultadosEvento;

  // seccion de Absolutos;
  var arrayPuntosControl = [];
  var JsonKPC = [];
  var JsonKPCPorTerminar = [];

  for (var i in JsonOrdenado) {
    var value = JsonOrdenado[i];

    arrayPuntosControl.push();

    var num = value.num;
    var nombre = value.nombre;
    var kpc = value.mod;
    var mod = value.mod;
    var pCat = 0;
    var tiempo = value.to;
    var parciales = value.parciales;
    var fechaHora = value.fhm;
    var registroSalida = value.registroSalida;

    // primera parte es la meta

    if (arrayPuntosControl.indexOf(pCat) == -1) {
      arrayPuntosControl.push(pCat);
    }

    var JsonObjeto = {};
    JsonObjeto.num = num;
    JsonObjeto.nombre = nombre;
    JsonObjeto.kpc = kpc;
    JsonObjeto.mod = mod;
    JsonObjeto.pCat = pCat;
    JsonObjeto.tiempo = tiempo;
    JsonObjeto.fechaHora = fechaHora;

    if (tiempo != "00:00:00" && (control == 0 || control == null)) {
      JsonKPC.push(JsonObjeto);
    }
    if (tiempo == "00:00:00" && registroSalida) {
      JsonKPCPorTerminar.push(JsonObjeto);
    }

    if (parciales != undefined && parciales != 0 && !soloMeta) {
      parciales.forEach(function (value2) {
        var kpc = value2.kpc;
        var pCat = value2.pCat;
        var tiempo = value2.tkpc;
        var fechaHora = value2.fechaHoraPunto;

        if (arrayPuntosControl.indexOf(pCat) == -1) {
          arrayPuntosControl.push(pCat);
        }

        var JsonParcial = {};
        JsonParcial.num = num;
        JsonParcial.nombre = nombre;
        JsonParcial.kpc = kpc;
        JsonParcial.mod = mod;
        JsonParcial.pCat = pCat;
        JsonParcial.tiempo = tiempo;
        JsonParcial.fechaHora = fechaHora;
        if (tiempo != "00:00:00" && (control == pCat || control == null)) {
          JsonKPC.push(JsonParcial);
        }
      });
    }
  }


  JsonKPC = helperMultisort(JsonKPC, ["fechaHora"], ["DESC"]);
  console.log("JsonKPC", JsonKPC);
  if (anouncer) {
    JsonKPC = JsonKPC.slice(0, 20);
  }

  return { JsonKPCPorTerminar: JsonKPCPorTerminar, JsonKPC: JsonKPC };
};

// ###########################################################################

// ###########################################################################
